import { global } from "../../constants";

export const data = {
  banner: {
    base: "政策",
    background: global.banner + "termscondition.webp",
    title: "使用条款与条件",
    crumb: "使用条款与条件",
  },
  icon: "fa-solid fa-file-contract",
  shortDescription:
    "规范访问和使用 ASEMARINSA 网站的通用条款，作为海运服务、咨询和保险的信息与联系渠道。",
  title: "使用条款与条件",
  description:
    "本文件规范访问和使用 ASEMARINSA 网站。该网站旨在作为公司所提供的海运服务、咨询及保险的信息与联系渠道。网站上发布的信息仅为一般参考，不构成直接的合同要约，也不支持通过本页面进行在线支付。任何商业或合同事宜均须通过 ASEMARINSA 的官方渠道在本站之外办理。",
  terms: [
    {
      index: 1,
      title: "目的",
      content:
        "本文件规范访问和使用 ASEMARINSA 网站。该网站旨在作为公司所提供的海运服务、咨询及保险的信息与联系渠道。网站上发布的信息仅为一般参考，不构成直接的合同要约，也不支持通过本页面进行在线支付。任何商业或合同事宜均须通过 ASEMARINSA 的官方渠道在本站之外办理。"
    },
    {
      index: 2,
      title: "访问与使用条件",
      content:
        "除互联网服务提供商产生的连接费用外，访问本网站是免费且开放的。仅因访问或使用本网站即表示您成为用户并完全接受这些条款与条件。ASEMARINSA 保留随时修改、更新或删除网站信息、配置或展示的权利，恕不另行通知。用户同意在遵守法律、道德与公共秩序的前提下浏览并使用站内内容，并对因其访问或使用而造成的任何损害承担全部责任。"
    },
    {
      index: 3,
      title: "禁止行为与义务",
      content:
        "尤其是，用户不得：（i）为非法目的或违背善意使用或访问本网站；（ii）向网站或第三方系统引入计算机病毒、恶意软件或其他有害代码；（iii）在未经 ASEMARINSA 明确授权的情况下复制、分发、改编或传播全部或部分站内内容；（iv）向其他用户发送未经请求的广告、连锁信息或垃圾邮件，或干扰网站的通信系统。若违反上述义务，用户将对由此产生的一切费用、损失和损害承担责任。ASEMARINSA 保留对任何非法行为采取适当法律行动的权利。"
    },
    {
      index: 4,
      title: "知识产权",
      content:
        "网站的所有元素（文本、图片、设计、标识、按钮、源代码等）均为 ASEMARINSA 所有或经第三方授权使用。对此类内容的全部知识产权和工业产权均予以保留。除经明确授权的情形外，不授予任何使用许可或权利。用户承诺始终尊重上述权利。任何未经授权使用站内内容（包括复制、再现或分发）均构成对本条款的违反，可能导致相应的法律责任。例如，网站上发布的照片、图形和文档未经 ASEMARINSA 书面许可不得使用；若被不当使用，用户应对因此造成的损害承担责任。"
    },
    {
      index: 5,
      title: "外部链接",
      content:
        "网站可能包含指向第三方网站的链接或引用。ASEMARINSA 提供这些链接仅为方便用户获取额外的相关资源。然而，ASEMARINSA 无法控制这些外部网站的内容，因此对其信息的完整性、真实性或适用性不承担任何责任。从外部页面建立指向 ASEMARINSA 网站的链接并不意味着 ASEMARINSA 对该等第三方网站的赞助、认可或负责。同样，用户访问外部资源需自行承担风险与责任。"
    },
    {
      index: 6,
      title: "责任限制",
      content:
        "本网站内容按“原样”提供，ASEMARINSA 不保证其不存在错误或遗漏。尽管 ASEMARINSA 采取合理措施以更新信息，但不能保证信息在任何时候均为准确、最新或完整。特别地，ASEMARINSA 对以下情形不承担任何责任：（i）所提供信息的错误或不准确；（ii）用户不当使用网站所导致的后果；（iii）基于网站内容而采取的决策；（iv）可能导致无法访问网站或其部分内容的中断、连接错误或技术故障；以及（v）通过本网站链接由第三方提供的内容或服务。用户在访问和使用本网站时明确接受这些限制与免责条款。"
    },
    {
      index: 7,
      title: "个人数据保护",
      content:
        "ASEMARINSA 遵守现行个人数据保护法规（例如欧盟 GDPR 及其在西班牙、巴拿马和委内瑞拉的本地实施）。用户通过本网站提供的数据的收集与处理，依据 ASEMARINSA 的隐私政策进行，用户可通过页脚相应链接访问该政策。根据该政策，ASEMARINSA 保证数据的机密性与安全，并将其使用限制在指定目的内（处理咨询、商业联系、发送信息等）。有关用户权利及处理方式的更多信息，请参阅本网站的隐私政策。"
    },
    {
      index: 8,
      title: "适用法律",
      content:
        "ASEMARINSA 与用户之间的关系应受各自适用法律的约束。补充性地，同意这些条款应依照西班牙法律解释，并且双方明确放弃任何其他管辖权，提交马德里市有管辖权的法院以解决任何争议。若某些用户或服务须强制适用巴拿马或委内瑞拉法律，则在该等特定情形中应适用该等法律。"
    },
    {
      index: 9,
      title: "滥用与修改通知",
      content:
        "任何未经授权或欺诈性使用本网站的行为可能会受到相应的法律追究。ASEMARINSA 保留随时修改网站展示、配置和内容以及本使用条款的权利，恕不另行通知。建议用户定期查看本节以了解当前版本。"
    }
  ],
  lastUpdate: "最后更新：2025年11月17日",
  misuseNotice:
    "重要提示：任何未经授权或欺诈性使用本网站的行为可能会受到法律追究。本使用条款可能会由 ASEMARINSA 随时修改。建议用户定期查看本节以了解最新版本。"
};
